var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.parentView)?_c('section',{staticClass:"main-body"},[_c('memberships-list')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }